import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorModal } from '@common-fe/common-fe';

import { SuccessModal } from '@/components/elements';
import PlaidModal from '@/utils/plaid/PlaidModal';

import { usePlaidBannerModalStore } from './store';

interface Props {
  refetch?: () => void;
}

export const PlaidBannerModals: React.FC<Props> = ({ refetch }) => {
  const { t } = useTranslation();
  const setErrorModal = usePlaidBannerModalStore((state) => state.setErrorModal);
  const setIsPlaidLoading = usePlaidBannerModalStore((state) => state.setIsPlaidLoading);
  const errorModal = usePlaidBannerModalStore((state) => state.errorModal);
  const isPlaidLoading = usePlaidBannerModalStore((state) => state.isPlaidLoading);
  const successModal = usePlaidBannerModalStore((state) => state.successModal);
  const setSuccessModal = usePlaidBannerModalStore((state) => state.setSuccessModal);
  return (
    <>
      {isPlaidLoading && (
        <PlaidModal
          visible
          isLoading
          onSetVisible={() => {
            setIsPlaidLoading(false);
          }}
        />
      )}
      <SuccessModal
        header={t('Your account has been successfully verified')}
        buttonText={t('Got It!')}
        visible={successModal}
        onSetVisible={() => {
          setSuccessModal(false);
          refetch?.();
        }}
        buttonStyle={{ width: '200px' }}
      />
      <ErrorModal
        testId="plaid-banner-error-modal"
        visible={errorModal}
        onSetVisible={() => {
          setErrorModal(false);
        }}
        header={t('Something went wrong')}
        helpText={t('Try again later')}
        buttonText={t('Got It!')}
        onSubmit={() => {
          setErrorModal(false);
        }}
      />
    </>
  );
};
